import * as React from 'react'

import type { SingleChoiceFilter } from 'generated/resources/datatable.graphql'

import { BOOLEAN_FILTER_KINDS } from 'modules/core/components/DataTable/constants'
import type { Filter as FilterType } from 'modules/core/components/DataTable/types'
import Filter from 'modules/core/components/Filter'

import Header from './Header'

type Props<T> = {
  filter: FilterType<T>
  onValueChange: (value: unknown) => void
  onCategoryChange: (category: FilterType<T>['category']) => void
  defaultOpen?: boolean
}

export default function BooleanFilter<T>({
  filter: dataTableFilter,
  onValueChange,
  onCategoryChange,
  defaultOpen,
}: Props<T>) {
  const { filter, category, value } = dataTableFilter

  const showHeader = filter.categories.length > 1
  const header = showHeader && (
    <Header filter={filter} category={category} onCategoryChange={onCategoryChange} />
  )

  const commonProps = {
    label: filter.title,
    onValueChange,
    header,
  }

  switch (category.kind) {
    case BOOLEAN_FILTER_KINDS.SINGLE_CHOICE:
      return (
        <Filter.SingleChoice
          options={category.options}
          value={value as SingleChoiceFilter<boolean>['value']}
          defaultOpen={defaultOpen}
          {...commonProps}
        />
      )
  }

  throw new Error(`Unknown filter kind: ${category.kind}`)
}
